import { Header, MobileNav, SideBar } from "../components";
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";


const MainLayout = () => {
  const [isOpenedSidebar, setIsOpenedSidebar] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleSideBar = () => {
    setIsOpenedSidebar(!isOpenedSidebar);
  };

  const handleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the threshold as needed
    };

    handleResize(); // Check on component mount

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="flex bg-secondary-n-20">
      { isMobile ? (
        <MobileNav mobileNav={isMobileNavOpen} handleMobileNav={handleMobileNav}  />
      ) : (
        <SideBar sidebar={isOpenedSidebar} />
      ) }
      <div className="flex flex-col w-full">  
        <Header handleSlideBar={handleSideBar} handleMobileNav={handleMobileNav} /> 
        <Outlet />
      </div>
    </section>
  );
};

export default MainLayout;
